import { render } from "./NotStartedIcon.vue?vue&type=template&id=586471e6"
import script from "./NotStartedIcon.vue?vue&type=script&lang=js"
export * from "./NotStartedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__